<template>
  <div>
    <div class="min-vh-100">
      <div class="mt-3 bg-white-border p-3">
        <!-- <b-row class="no-gutters my-3">
          <b-col lg="4">
            <b-input-group class="panel-input-serach">
              <b-form-input
                class="input-serach"
                placeholder="Username"
                @keyup="handleSearch"
                v-model="filter.search"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
          <b-col lg="6" class="text-center text-sm-right"> </b-col>
        </b-row> -->
        <b-row class="no-gutters px-3 px-sm-0 mb-3">
          <b-col class="text-right">
            <b-button variant="success" @click="exportExcel" :disabled="isExporting">
              <b-spinner v-if="isExporting" small class="mr-1"></b-spinner>
              {{ isExporting ? 'Exporting...' : 'Export Excel' }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col>
            <b-table
              class="table-list"
              striped
              responsive
              hover
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
            
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(imageUrl)="data">
                <div class="d-flex justify-content-center">
                  <b-img
                    class="box-image1-1"
                    :src="data.item.imageUrl"
                    fluid
                    @click="showImageModal(data.item.imageUrl)"
                  ></b-img>
                </div>
              </template>
              <template v-slot:cell(createTime)="data">
                <div class="d-flex justify-content-center">
                  {{
                    new Date(data.item.createTime) | moment($formatDateTimeSec)
                  }}
                </div>
              </template>
              <template v-slot:cell(updatedTime)="data">
                <div class="d-flex justify-content-center">
                  {{
                    new Date(data.item.updatedTime) | moment($formatDateTimeSec)
                  }}
                </div>
              </template>
              <template v-slot:cell(responseReceiptDate)="data">
                <div class="d-flex justify-content-center">
                  <template v-if="data.item.responseReceiptDate && data.item.responseReceiptDate !== '0001-01-01T00:00:00'">
                    {{ new Date(data.item.responseReceiptDate) | moment($formatDateTimeSec) }}
                  </template>
                  <template v-else>-</template>
                </div>
              </template>
              <template v-slot:cell(markdownFromOcr)="data">
                <div class="text-truncate" style="max-width: 200px;">
                  {{ data.item.markdownFromOcr || '-' }}
                </div>
              </template>
              <template v-slot:cell(jsonAfterChatGptPrompt)="data">
                <div class="text-truncate" style="max-width: 200px;">
                  {{ data.item.jsonAfterChatGptPrompt ? JSON.stringify(data.item.jsonAfterChatGptPrompt) : '-' }}
                </div>
              </template>
              <template v-slot:cell(jsonResponseToCrm)="data">
                <div class="text-truncate" style="max-width: 200px;">
                  {{ data.item.jsonResponseToCrm ? JSON.stringify(data.item.jsonResponseToCrm) : '-' }}
                </div>
              </template>
              <template v-slot:cell(reponseResult)="data">
                <div class="d-flex justify-content-center">
                  <!-- <div>
                    <b-button @click="showModal(data.item)">Show</b-button>
                  </div> -->
                  <div>
                    <b-button @click="showModalMarkdown(data.item)">Show Markdown</b-button>
                  </div>
                  <div>
                    <b-button @click="showModalJsonGPT(data.item)">Show JSON GPT</b-button>
                  </div>
                  <div>
                    <b-button @click="showModalJsonToCRM(data.item)">Show JSON To CRM</b-button>
                  </div>
                  <div>
                    <b-button
                      @click="showModalAll(data.item)"
                      class="text-nowrap ml-2"
                      >Show All</b-button
                    >
                  </div>
                  <div>
                    <b-button
                      @click="copyImageBase64(data.item)"
                      class="text-nowrap ml-2"
                      variant="outline-primary"
                    >Copy Base64</b-button>
                  </div>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <!-- <b-row class="no-gutters px-3 px-sm-0">
          <b-col
            class="form-inline justify-content-center justify-content-sm-between"
          >
            <div v-if="rows > 0" class="my-auto">
              Showing {{ startPage }} to {{ endPage }} of {{ rows }} entires
            </div>
            <div v-else class="my-auto">{{ rows }} entire</div>
            <div class="d-sm-flex m-3">
              <b-pagination
                v-model="filter.pageNo"
                :total-rows="rows"
                :per-page="filter.perPage"
                class="m-md-0"
                @change="pagination"
                align="center"
              ></b-pagination>
            </div>
          </b-col>
        </b-row> -->
      </div>
    </div>
    <div>
      <b-modal id="modal-tall" title="Overflowing Content" size="lg">
        <div>
          <pre>{{ textShow }}</pre>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="modal-markdown" title="Markdown Preview" size="lg">
        <div class="markdown-body" v-html="markdownHtml"></div>
      </b-modal>
    </div>
    <div>
      <b-modal id="modal-image" title="Image Preview" size="xl" hide-footer centered>
        <div class="text-center">
          <b-img :src="previewImageUrl" fluid></b-img>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { marked } from "marked";

export default {
  name: "UserIndex",
  components: {},
  data() {
    return {
      textShow: "",
      markdownHtml: "",
      previewImageUrl: "",

      selected: null,
      options: [{ value: null, text: "สถานะ" }],
      statusList: [],
      modalMessage: "",
      startPage: 1,
      endPage: 10,
      activeItem: "",
      requestDeleteUser: {
        userId: null
      },
      fields: [
        { key: "id", label: "ID", class: "text-center" },
        { key: "createTime", label: "Create Time", class: "text-center" },
        { key: "updatedTime", label: "Updated Time", class: "text-center" },
        { key: "usedTime", label: "Time Used", class: "text-center" },
        { key: "predictionId", label: "Prediction ID", class: "text-center" },
        { key: "imageUrl", label: "Image", class: "text-center" },
        { key: "requestId", label: "Request ID", class: "text-center" },
        { key: "typeId", label: "Type ID", class: "text-center" },
        { key: "statusId", label: "Status ID", class: "text-center" },
        { key: "responseBranchId", label: "Branch ID", class: "text-center" },
        { key: "responseInvoiceNo", label: "Invoice No", class: "text-center" },
        { key: "responseGrantotal", label: "Grand Total", class: "text-center" },
        { key: "responseReceiptDate", label: "Receipt Date", class: "text-center" },
        { key: "reponseResult", label: "Result", class: "text-center" },
        { key: "responseErrorTypeId", label: "Error Type ID", class: "text-center" },
        // { key: "markdownFromOcr", label: "Markdown From OCR", class: "text-center" },
        // { key: "jsonAfterChatGptPrompt", label: "JSON After ChatGPT", class: "text-center" },
        // { key: "jsonResponseToCrm", label: "JSON Response To CRM", class: "text-center" },
      ],
      items: [],
      isBusy: false,
      value: false,
      rows: 0,
      filter: {
        search: "",
        pageNo: 1,
        perPage: 10
      },
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" }
      ],
      totalRowMessage: "",
      isDisable: false,
      checkAll: false,
      selectAllCb: false,
      isExporting: false
    };
  },
  created: async function () {
    await this.getList();
    this.getShowingPage(1);
  },
  methods: {
    getList: async function () {
      this.isBusy = true;
      await this.axios
        .get(`${this.$baseUrl}/ReceiptDetection/ListLog`, this.filter)
        .then(res => {
          // console.log(res.data);
          if (res.data.result == 1) {
            res.data.detail.forEach((element, idx) => {
              // Assuming element.created and element.updated are in the "2024-08-09T18:39:04" format
              const date1 = new Date(element.createTime);
              const date2 = new Date(element.updatedTime);

              // Log to see if we have valid Date objects
              console.log('Created Date:', date1);
              console.log('Updated Date:', date2);

              if (isNaN(date1) || isNaN(date2)) {
                res.data.detail[idx].usedTime = ''
                return; // Skip this iteration if dates are invalid
              }

              const diffInMillis = date2 - date1;

              const totalSeconds = Math.floor(diffInMillis / 1000);
              const minutes = Math.floor(totalSeconds / 60);
              const seconds = totalSeconds % 60;

              res.data.detail[idx].usedTime = minutes + ":" + String(seconds).padStart(2, '0') + " นาที";
            });

            this.items = res.data.detail;

            // this.rows = data.detail.count;
            this.isBusy = false;

            console.log(this.items);
          }
        });
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.pageNo = 1;
        this.getList();
      }
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
      this.getShowingPage(Page);
    },
    getShowingPage(Page) {
      const totalRow = this.rows;
      this.startPage = (Page - 1) * this.filter.perPage + 1;
      if (Page * this.filter.perPage <= totalRow) {
        this.endPage = Page * this.filter.perPage;
      } else {
        this.endPage = totalRow;
      }
    },
    hanndleChangePerpage(value) {
      this.filter.pageNo = 1;
      this.filter.perPage = value;
      this.getList();
    },
    // showModal(val) {
    //   console.log(ddddd);

    //   let ddddd = JSON.parse(val.Response);
    //   console.log(ddddd.PredictionDetail?.GoogleOCRText);
    //   this.textShow = ddddd.PredictionDetail?.GoogleOCRText || "-";
    //   this.$root.$emit("bv::show::modal", "modal-tall", "#btnShow");
    // },
    showModalMarkdown(val) {
      // convert string to json
      let jsonResponse = JSON.parse(val.response);
      this.markdownHtml = jsonResponse?.ReconciledText ? marked(jsonResponse.ReconciledText) : "-";

      if (!this.markdownHtml) {
        this.markdownHtml = val.markdownFromOcr ? marked(val.markdownFromOcr) : "-";
      }

      this.$root.$emit("bv::show::modal", "modal-markdown", "#btnShow");
    },
    showModalJsonGPT(val) {
      if (!val.jsonAfterChatGptPrompt) {
        this.textShow = "-";
      } else {
        this.textShow = JSON.stringify(val.jsonAfterChatGptPrompt, null, 2);
      }
      this.$root.$emit("bv::show::modal", "modal-tall", "#btnShow");
    },
    showModalJsonToCRM(val) {
      if (!val.jsonResponseToCrm) {
        this.textShow = "-";
      } else {
        this.textShow = JSON.stringify(val.jsonResponseToCrm, null, 2);
      }
      this.$root.$emit("bv::show::modal", "modal-tall", "#btnShow");
    },
    async exportExcel() {
      this.isExporting = true;
      try {
        const res = await this.axios.get(
          `${this.$baseUrl}/ReceiptDetection/ListLogExport`,
          {
            params: { limit: 1000 },
            responseType: "blob"
          }
        );
        const blob = new Blob([res.data], {
          type: res.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "LogExport.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Export failed:", err);
        alert("Export failed");
      } finally {
        this.isExporting = false;
      }
    },
    async copyImageBase64(val) {
      const base64 = val.imageBase64;
      if (!base64) {
        alert("No ImageBase64 data available");
        return;
      }
      try {
        await navigator.clipboard.writeText(base64);
        alert("Copied ImageBase64 to clipboard");
      } catch (err) {
        console.error("Copy failed:", err);
        alert("Failed to copy");
      }
    },
    showImageModal(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.$root.$emit("bv::show::modal", "modal-image");
    },
    showModalAll(val) {
      if (!val.response) {
        this.textShow = "-";
      } else {
        this.textShow = JSON.parse(val.response);
      }
      this.$root.$emit("bv::show::modal", "modal-tall", "#btnShow");
    }
  }
};
</script>

<style lang="scss" scoped>
.action-div {
  text-align: end;
}

::v-deep .hover-image-popover {
  &.b-popover {
    border: none !important;
    margin-left: 8px;
  }

  .popover-body {
    padding: 0;
    width: 50vw !important;
  }
}

.box-image1-1 {
  cursor: zoom-in;
}
.img-fluid {
  width: 100% !important;
}

.hover-preview {
  width: 40vw !important;
  background-repeat: no-repeat;
}

::v-deep .modal-dialog {
  max-width: 800px;
}

::v-deep .markdown-body {
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1rem;
  }
  th, td {
    border: 1px solid #dee2e6;
    padding: 0.5rem;
  }
  th {
    background-color: #f8f9fa;
  }
  p {
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 767px) {
  .action-div {
    text-align: center;
  }
}
</style>
